import { getHomeRolesFromUser, readActiveHomeRole, userHasAdminRole } from "./homeRole";

/**
 * Club Admin / Super Admin only may turn on, configure, preview, and close
 * the Pingflo newsletter cycle. Coaches, players, and other roles can still
 * read published issues.
 */
export function userCanManageNewsletter(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || Number(user.type_user_id) === 1) return true;
  if (!userHasAdminRole(user)) return false;
  // Dual-role users only manage while viewing as Admin — not Coach/Player.
  return readActiveHomeRole(user) === "admin";
}

/**
 * Coaches and club admins may add announcements, news, and links to the next
 * issue, while viewing as Coach or Admin.
 */
export function userCanPostNewsletter(user) {
  if (!user) return false;
  if (userCanManageNewsletter(user)) return true;
  if (!getHomeRolesFromUser(user).includes("coach")) return false;
  const active = readActiveHomeRole(user);
  return active === "coach" || active === "admin";
}
